import { render, staticRenderFns } from "./ProcessNewVinculation.vue?vue&type=template&id=05dd4c22&scoped=true"
import script from "./ProcessNewVinculation.vue?vue&type=script&lang=js"
export * from "./ProcessNewVinculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd4c22",
  null
  
)

export default component.exports